define([
    'lodash',
    'components',
    'componentsCore',
    'santa-components'
], function (
    _,
    components,
    componentsCore,
    santaComponents
) {
    'use strict';

    const tagNamePropTypes = {
        isParentRefComponent: santaComponents.santaTypesDefinitions.Component.isParentRefComponent
    };
    const getTagNameProp = (configTagName, {isParentRefComponent}) => configTagName && !isParentRefComponent && {tagName: configTagName};
    const afterScrollPropTypes = {
        isPlayingAllowed: santaComponents.santaTypesDefinitions.RenderFlags.isPlayingAllowed.isRequired,
        isAfterScroll: santaComponents.santaTypesDefinitions.HeaderContainer.isAfterScroll.isRequired
    };
    const getScrollDataState = ({isAfterScroll, isPlayingAllowed}) => ({
        ['data-state']: [isAfterScroll && 'scrolled', isPlayingAllowed && 'transition-allowed'].filter(Boolean).join(' ')
    });

    const {containerFactory} = santaComponents.factories;
    const mediaCommon = components.mediaCommon;

    const sectionDefinition = containerFactory({
        displayName: 'HeaderSection',
        compType: 'responsive.components.HeaderSection',
        defaultSkinName: 'wysiwyg.viewer.skins.area.RectangleArea',
        tagName: 'header',
        hasBackground: true,
        extraPropTypes: _.assign({}, tagNamePropTypes, afterScrollPropTypes),
        getExtraRootProps: props => _.merge(getScrollDataState(props), getTagNameProp('header', props)),
        isPlayingAllowed: santaComponents.santaTypesDefinitions.RenderFlags.isPlayingAllowed.isRequired,
        isAfterScroll: santaComponents.santaTypesDefinitions.HeaderContainer.isAfterScroll.isRequired
    });

    return _.assign({}, sectionDefinition, {
        propTypes: _.assign({},
            sectionDefinition.propTypes,
            {compDesign: santaComponents.santaTypesDefinitions.Component.compDesign}
        ),
        mixins: [
            ...sectionDefinition.mixins,
            mediaCommon.mediaLogicMixins.fill,
            componentsCore.mixins.createChildComponentMixin
        ],
        statics: _.assign({},
            sectionDefinition.statics,
            {
                behaviors: _.assign({},
                    sectionDefinition.statics.behaviros,
                    mediaCommon.mediaBehaviors.fill
                )
            }
        ),
        getSkinProperties() {
            const def = sectionDefinition.getSkinProperties.apply(this);
            if (!_.isEmpty(this.props.compDesign)) {
                def.bg = this.createFillLayers({
                    mediaDimensions: this.props.mediaDimensions
                });
            }
            return def;
        }
    });
});
